export default __webpack_public_path__ + "roboto-v27-latin-700italic.3d7ada.woff";